import { createApi } from '@reduxjs/toolkit/query/react';
import baseQueryWithReauth from '@/pages/shared/base-query-auth';
import { runTableQuery, runQueryOnce, stripEmptyParams } from '@/pages/shared/rtk-query-helpers';

export const deletedDocumentsApi = createApi({
    reducerPath: 'deletedDocumentsApi',
    baseQuery: baseQueryWithReauth,
    endpoints: (builder) => ({
        getTableData: builder.mutation({
            query: (data) => ({ url: '/api/document/deleted/list', method: 'POST', body: data }),
        }),
        // The three filter lookups are refetched imperatively whenever a sibling filter
        // changes, so cache entries are released after each call rather than shadowing
        // that behaviour.
        getSitesFilter: builder.query({
            query: () => ({ url: '/api/document/deleted/sitesList', method: 'GET' }),
            keepUnusedDataFor: 0,
        }),
        getCategoryFilter: builder.query({
            query: ({ siteId, subcategory }) => ({
                url: '/api/document/deleted/categoriesList',
                method: 'GET',
                params: stripEmptyParams({ siteId, subcategory }),
            }),
            keepUnusedDataFor: 0,
        }),
        getSubcategoryFilter: builder.query({
            query: ({ siteId, category }) => ({
                url: '/api/document/deleted/subCategoriesList',
                method: 'GET',
                params: stripEmptyParams({ siteId, category }),
            }),
            keepUnusedDataFor: 0,
        }),
    }),
});

export const {
    useGetSitesFilterQuery,
    useGetCategoryFilterQuery,
    useGetSubcategoryFilterQuery,
} = deletedDocumentsApi;

/**
 * Runs a `deletedDocumentsApi` filter query once and releases its cache subscription.
 */
export const runDeletedDocumentsQuery = (dispatch, endpointName, arg) =>
    runQueryOnce(dispatch, deletedDocumentsApi.endpoints[endpointName], arg);

/**
 * Loads the deleted documents table, wrapped in the `{ data }` envelope that the shared
 * `getTableData` thunk still expects from a table `request` function.
 */
export const runDeletedDocumentsTableQuery = (dispatch, requestData) =>
    runTableQuery(dispatch, deletedDocumentsApi.endpoints.getTableData, requestData);

export default deletedDocumentsApi;
